<template>
  <van-collapse v-model="activeNames" v-if="ht" accordion>
    <van-collapse-item title="对应合同" name="1">
      <xsht  v-if="ht.htid" :htid="ht.htid"></xsht>

      </van-collapse-item>
    <van-collapse-item title="开票详情" name="2">
      <van-cell title="合同编号"  :label="ht.htbh" />
      <van-cell title="开票号"  :label="ht.kph" />

              <van-cell title="开票人"  :label="ht.kpr" />
                     <van-cell title="抬头"  :label="ht.fpmc" />
                     <van-cell title="税号"  :label="ht.fpsh" />
                     <van-cell title="联系电话"  :label="ht.lxrdh" />
                     <van-cell title="开户行"  :label="ht.fpkhyh" />
                     <van-cell title="开户账号"  :label="ht.fpyhzh" />

       <van-cell title="开票日期"  :value="U.parseTime(ht.kprqDate,'{y}-{m}-{d}')" />
      <van-cell title="开票金额"  :value="ht.kpje" />
    <!--  <van-cell title="不含税金额"  :value="ht.bhsje" /> -->
      <van-cell title="开票类型"  :value="ht.kplx" />
      <van-cell title="委托单位"  :value="getwtdw(ht.wtdw)" />
      <van-cell title="税率"  :value="ht.tax" />
    <!--  <van-cell title="销项税"  :value="ht.sfje" /> -->
       <van-cell title="备注"  :label="ht.bz" />
     <van-cell v-if="ht.fjwj" title="附加文件"  >
          <template #label>
            <Filedownload :srcs="ht.fjwj"></Filedownload>
          </template>
      </van-cell>

    </van-collapse-item>

  </van-collapse>
</template>

<script>
import {getDicts, getDictLabel} from '@/utils/dicts'
import cght from './cght.vue'
import xsht from './xsht.vue'
import Filedownload from '../../components/FileDownload/index.vue'
export default {
  name: 'kp',
  components: {
    xsht: xsht,
    cght: cght,
    Filedownload: Filedownload
  },
  props: {
    htid: {
      type: [String, Number],
      default: null
    },
    ht: {
      type: Object,
      default: null
    }
  },
  data () {
    return {

      activeNames: '2',
      dicts: [],

      depts: [],

      loading: false

    }
  },
  created () {
    console.log('kp', this.htid, this.ht)

    this.getdepts()
    this.getdicts()
    this.getHt()
  },
  watch: {
    // 是否显示提示
    htid (nv, ov) {
      console.log(nv, this.htid)
      this.ht = null
      this.htid = nv
      this.getHt()
    }
  },
  methods: {
    getwtdw (wtdw) {
      return getDictLabel('xm_wtdw', wtdw)
    },
    getdepts () {
      let that = this
      this.$ajax.get('/system/dept/list').then(res => {
        that.depts = res.data
      })
    },
    getdicts () {
      let that = this
      if (this.dicts.length > 0) {
        for (let d of this.dicts) {
          // console.log("d",d)
          this.$ajax.get('/system/dict/data/type/' + d).then(res => {
            that.dict.type[d] = res.data
            //  console.log(that.dict)
          })
        }
      }
    },
    getHt () {
      let that = this
      if (this.ht) return
      else {
        this.$ajax.get('/xm/htkp/' + this.htid).then(function (res) {
          if (res.code == 200) {
            that.ht = res.data
            console.log('that.kpht', res.data)
          }
        })
      }
    }

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Zsmb/kp.vue